import ApiRequest from "../../common/lib/apiRequest";

const mutationTypes = {
  SET_USER_BASIC_INFO: "userInfo/SET_USER_BASIC_INFO",
  UPDATE_INFO: "userInfo/UPDATE_INFO",
  SET_UPDATE_INFO_RES: "userInfo/SET_UPDATE_INFO_RES",
  CHANGE_PASSWORD: "userInfo/CHANGE_PASSWORD",
  SET_CHANGE_PASSWORD_INFO: "userInfo/SET_CHANGE_PASSWORD_INFO",
};

const state = {
  basicInfo: null,
  updateInfo: {
    isSubmitting: false,
    isSubmitted: false,
    error: null,
  },
  changePassword: {
    isSubmitting: false,
    isSubmitted: false,
    error: null,
  },
};

const actions = {
  async getUserBasicInfo({ commit }) {
    const info = await ApiRequest.get("/user");
    info.verificationStatus = info.verificationStatus || "new";
    commit(mutationTypes.SET_USER_BASIC_INFO, info);
  },
  async updateInfo({ commit }, payload) {
    commit(mutationTypes.UPDATE_INFO);
    try {
      await ApiRequest.patch("/user", {
        first_name: payload.firstName,
        last_name: payload.lastName,
        subscribe_mailing_list: payload.subscribed,
      });
      commit(mutationTypes.SET_UPDATE_INFO_RES, { isSubmitted: true });
      commit(mutationTypes.SET_USER_BASIC_INFO, {
        subscribeMailingList: payload.subscribed,
        firstName: payload.firstName,
        lastName: payload.lastName,
      });
    } catch (error) {
      commit(mutationTypes.SET_UPDATE_INFO_RES, { error });
    }
  },
  async changePassword({ commit }, payload) {
    commit(mutationTypes.CHANGE_PASSWORD);
    try {
      await ApiRequest.post("/auth/change_password", {
        current_passwd: payload.currentPassword,
        new_passwd: payload.newPassword,
      });
      commit(mutationTypes.SET_CHANGE_PASSWORD_INFO, { isSubmitted: true });
    } catch (error) {
      commit(mutationTypes.SET_CHANGE_PASSWORD_INFO, { error });
    }
  },
  async sendKycRequest({ commit, state }) {
    await ApiRequest.post("/user/request_verification");
    const info = state.basicInfo;
    commit(mutationTypes.SET_USER_BASIC_INFO, {
      ...info,
      verificationStatus: "pending_submission",
    });
  },
};

const mutations = {
  [mutationTypes.SET_USER_BASIC_INFO](state, data) {
    state.basicInfo = {
      ...(state.basicInfo || {}),
      ...data,
    };
  },
  [mutationTypes.UPDATE_INFO](state) {
    state.updateInfo = {
      isSubmitting: true,
      isSubmitted: false,
      error: null,
    };
  },
  [mutationTypes.SET_UPDATE_INFO_RES](state, data) {
    state.updateInfo = {
      ...state.updateInfo,
      isSubmitting: false,
      ...data,
    };
  },
  [mutationTypes.CHANGE_PASSWORD](state) {
    state.changePassword = {
      isSubmitting: true,
      isSubmitted: false,
      error: null,
    };
  },
  [mutationTypes.SET_CHANGE_PASSWORD_INFO](state, data) {
    state.changePassword = {
      ...state.changePassword,
      isSubmitting: false,
      ...data,
    };
  },
};

const getters = {
  basicInfo: state => state.basicInfo,
  updateInfo: state => state.updateInfo,
  changePassword: state => state.changePassword,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
